import L from "leaflet";

const SpeedEventIcon = (speed: number) => {
  return L.divIcon({
    className: "custom-speed-marker",
    html: `
        <div class="relative">
          <div class="absolute -translate-x-1/2 -translate-y-1/2 p-2 rounded-full shadow-lg bg-amber-500 border-2 border-amber-800">
            <span class="text-white font-bold text-xs">${speed}</span>
          </div>
        </div>
      `,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
  });
};

export default SpeedEventIcon;
